<div class="site-search-content flex-row justify-start align-start gap-10">
  <!-- icon prefix-->
  <mat-icon matPrefix
    class="site-search-icon"
  (click)="openSiteSearchText()">search</mat-icon>
  <!-- text-->
  <!-- Placeholder -->
  @if (!site) {
    <div
      class="site-search-text"
      (click)="openSiteSearchText()">
      {{ "WELCOME.SEARCH.PLACEHOLDER" | transloco }}
    </div>
  }
  <!-- Selected-->
  @if (site) {
    <div
      class="site-search-text selected"
      (click)="openSiteSearchText()">
      <span>{{ site.name }}</span>
      @if (searchMode==='restaurant') {
        <span>, {{ site.restaurants[0].name}}</span>
      }
      <span>, {{ site.address }}</span>
    </div>
  }
  <!-- icon position actuelle-->
  <!-- svgIcon="location_arrow" -->

  <mat-icon [color]="isByLocation ? 'primary' : 'default'"
    matRipple
    matSuffix
    class="site-search-location-icon"
  (click)="openSiteSearchLocation()">gps_fixed</mat-icon>
</div>
